module.exports = __webpack_public_path__ + "static/media/onde-comprar-phone.3b29d7ad.svg";